import { render, staticRenderFns } from "./MainNavV2.vue?vue&type=template&id=59244caf&scoped=true&"
import script from "./MainNavV2.vue?vue&type=script&lang=js&"
export * from "./MainNavV2.vue?vue&type=script&lang=js&"
import style0 from "./MainNavV2.vue?vue&type=style&index=0&id=59244caf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59244caf",
  null
  
)

export default component.exports